import React from 'react';

import { Provider } from "react-redux";
import NavBar from "./components/NavBar";
import { useAuth0 } from './react-auth0-spa';
import { Playground, store } from "graphql-playground-react";
import PrivateRoute from './components/PrivateRoute';
import { Router, Switch } from "react-router-dom";
import history from './utils/history';

import './App.css';

const settings = {
  "tracing.tracingSupported": false,
  "tracing.hideTracingResponse": false
}

const ThePlayground = () => {

  return (
    <Provider store={store}>
      <Playground 
        endpoint="https://api-staging-k8s.betterpt.com/v0/graphql-public"
        settings={settings}
        />
    </Provider>
  );
}

function App() {
  const { loading } = useAuth0();

  if (loading) {
    return <div style={{ padding: 20, color: 'white' }}>Loading...</div>;
  }

  return (
    <Router history={history}>
      <div id="app" className="d-flex flex-column h-100">
        <NavBar />
        <Switch>
          <PrivateRoute path="/" component={ThePlayground} />
        </Switch>
      </div>
    </Router>
  );
}
export default App;

